import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import { AgentActivitiesService } from './agentActivititesApi';
import { IAgentActivitiesListState } from '../../../../interfaces/agent-activitites/IAgentActivitiesList';


const initialState: IAgentActivitiesListState = {
    activityIsLoading: false,
    activitiesAreLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchActivities = createAsyncThunk<any, IPaginationPayload>(
    'agentActivities/tryToFetchActivities',
    async ({ pageNumber, pageSize, data }) => {
        const result = await AgentActivitiesService.tryToFetchActivities(pageNumber, pageSize, data);
        return result?.data;
    },
);

export const agentActivitiesSlice = createSlice({
    name: 'agentActivities',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchActivities
            .addCase(tryToFetchActivities.pending, (state) => {
                state.activitiesAreLoading = true;
            })
            .addCase(tryToFetchActivities.rejected, (state) => {
                state.activitiesAreLoading = false;
            })
            .addCase(tryToFetchActivities.fulfilled, (state, action) => {
                state.activitiesAreLoading = false;
                state.agentActivities = action.payload;
            })
    },
});

export default agentActivitiesSlice.reducer;